import headerPage from '../components/layout/header.vue'
import navbarPage from '../components/layout/slidebar.vue'
import footerPage from '../components/layout/footer.vue'

export default {
  name: 'app',
  components: {
    headerPage,
    navbarPage,
    footerPage
  }
}



// WEBPACK FOOTER //
// ./src/js/app.js